/* ============================================================
   wl-main-visual.js — メインビジュアル スライドショー
   schema の autoplay / speed 設定を data 属性経由で受け取る。
   ドットは JS で動的生成する（Liquid 側は空の <div class="wl-mv__dots"> のみ）。
   矢印ナビゲーション（PC）・タッチスワイプ（スマホ）対応。
   ============================================================ */
(function () {
  'use strict';

  /* ---- 1インスタンス分の初期化 ---- */
  function initMV(mv) {
    var slides   = mv.querySelectorAll('.wl-mv__slide');
    var dotsWrap = mv.querySelector('.wl-mv__dots');
    var prevBtn  = mv.querySelector('.wl-mv__arrow--prev');
    var nextBtn  = mv.querySelector('.wl-mv__arrow--next');
    var current  = 0;
    var timer    = null;

    /* schema 設定を data 属性から取得 */
    var autoplay = mv.getAttribute('data-autoplay') === 'true';
    var speed    = Math.min(10, Math.max(1, parseInt(mv.getAttribute('data-speed'), 10) || 5)) * 1000;

    /* prefers-reduced-motion：自動切換えを停止（アクセシビリティ） */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoplay = false;
    }

    /* スライドが0枚または1枚の場合は何もしない */
    if (slides.length <= 1) return;

    /* ---- ドットを動的生成 ---- */
    if (dotsWrap) {
      Array.prototype.forEach.call(slides, function (slide, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wl-mv__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', (i + 1) + '枚目のスライドに移動');
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(btn);
      });
    }

    /* ---- スライド切替 ---- */
    function goTo(index) {
      /* 現在のスライドを非アクティブ化 */
      slides[current].classList.remove('is-active');
      updateDot(current, false);

      /* 新しいスライドをアクティブ化 */
      current = index;
      slides[current].classList.add('is-active');
      updateDot(current, true);

      /* autoplay 中はタイマーをリセット（クリック後もインターバルを継続） */
      if (autoplay) resetTimer();
    }

    function updateDot(index, isActive) {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.wl-mv__dot');
      if (!dots[index]) return;
      dots[index].classList.toggle('is-active', isActive);
      dots[index].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function prev() {
      goTo((current - 1 + slides.length) % slides.length);
    }

    /* ---- 矢印ボタン ---- */
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });

    /* ---- タッチ・スワイプ（スマホ対応） ---- */
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwiping   = false;

    mv.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping   = false;
    }, { passive: true });

    mv.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      /* 水平スワイプと判定したら縦スクロールとリンクタップを抑制 */
      if (dx > 10 && dx > dy) {
        isSwiping = true;
        e.preventDefault();
      }
    }, { passive: false });

    mv.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      var deltaX = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) < 50) { isSwiping = false; return; }
      if (deltaX < 0) { next(); } else { prev(); }
      isSwiping = false;
    });

    /* ---- autoplay ---- */
    function startTimer() {
      timer = setInterval(next, speed);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    if (autoplay) startTimer();
  }

  /* ---- ページ内の全インスタンスを初期化 ---- */
  function init() {
    var sections = document.querySelectorAll('.wl-main-visual');
    Array.prototype.forEach.call(sections, function (el) {
      /* 二重初期化を防ぐ（テーマエディタの再レンダリング対応） */
      if (el.dataset.mvInit) return;
      el.dataset.mvInit = '1';
      initMV(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---- テーマエディタ対応 ---- */
  /* セクションが再描画されたら data-mv-init をリセットして再初期化 */
  document.addEventListener('shopify:section:load', function (event) {
    var mv = event.target.querySelector('.wl-main-visual');
    if (!mv) return;
    delete mv.dataset.mvInit;
    /* ドットが残っている場合はクリア */
    var dotsWrap = mv.querySelector('.wl-mv__dots');
    if (dotsWrap) dotsWrap.innerHTML = '';
    initMV(mv);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var mv = event.target.querySelector('.wl-main-visual');
    if (!mv) return;
    /* 選択時は強制的に1枚目を表示 */
    var slides = mv.querySelectorAll('.wl-mv__slide');
    if (slides.length > 0) {
      Array.prototype.forEach.call(slides, function (s) { s.classList.remove('is-active'); });
      slides[0].classList.add('is-active');
    }
  });
})();
